import React from "react";
import defaultOurStoryImage from "../../../assets/about-story-image.png";
import BoxBG from "../../../assets/get-demo-section-bg.jpg";

function OurStorySection({ acfData }) {
  // Default content
  const defaultTitle = "Our Story";
  const defaultDetails = `Laguna Creek was founded to grow Native American tourism to new heights, and keep more tourism dollars on Native land so all Indigenous people benefit. Why? For two reasons.

First, we grew up on the rez. While we saw businesses come and go, whether it was coal companies, mining, or others, they almost always were owned by people who lived far away from us - with headquarters sometimes overseas. The money generated by the hard work of Native employees almost never stayed close to home.

Second, we watched the COVID-19 pandemic decimate the Native tourism economy - destroying countless jobs for our people. We saw the devastating effect of the huge decline of tourism, not just for tours and hotels, but surrounding restaurants and shops.

We knew that we had to empower local tour operators and hotels, so they had the tools they needed to grow their business, while lowering their expenses. We also believed so strongly in keeping those dollars on Native land that we decided to dedicate 10% of all net profits to charitable work on the reservation.

Today, after years of research and development, we are proud to offer Laguna Creek - the all in one Property Management, Point of Sale and Booking platform. Laguna Creek allows tourists to book their hotel, tour, restaurant reservation and purchase retail items - in one place - while saving Indigenous business owners huge costs in merchant fees, booking fees and subscriptions.

Being able to easily manage your property, while saving your staff hours of their time (and headaches), is a game-changer for the industry. And allowing Indigenous tours, retail shops, and hotels to work together and cross promote is a game-changer for Indigenous tourism itself.

Want to learn more? Schedule a free demo today, and let us show you how Laguna Creek can help your business - and your community.`;
  const defaultImage = defaultOurStoryImage;
  const defaultCaption =
    "Image of Wyatt (CEO) and Lane (Prod Manager) and cousin in high school while growing up on the Rez";

  const defaultTitleMission = "Our Mission";
  const defaultTitleMissionDetail = "Boosting the Indigenous economy by keeping more tourism, retail and hospitality dollars on Indigenous land.";

  const title = acfData?.our_story_title || defaultTitle;
  const rawDetails = acfData?.our_story_details || defaultDetails;
  const image = acfData?.our_story_detail_image || defaultImage;
  const caption = acfData?.our_story_detail_image_caption || defaultCaption;
  const titleMission = acfData?.our_mission_title || defaultTitleMission;
  const titleMissionDetail = acfData?.our_mission_detail || defaultTitleMissionDetail;

  // Convert text to array of paragraphs (based on newlines)
  const paragraphs = rawDetails.split(/\r?\n/).filter((p) => p.trim() !== "");

  // Map over paragraphs with keys
  const contentWithImage = paragraphs.map((text, idx) => (
    <p
      key={`para-${idx}`}
      className="text-lg font-light leading-7 text-[#333333] mb-4"
    >
      {text}
    </p>
  ));

  // Create the image block with a key
  const imageBlock = (
    <div key="ourstory-image-block">
      {/* Desktop image */}
      <div className="hidden lg:block float-right clear-both rounded-[21px] ml-16 2xl:ml-24 2xl:mr-24 mb-10 text-center">
        <img
          src={image}
          alt="OurStory"
          className="w-full mb-2"
          height="841"
          width="663"
        />
        <p className="max-w-[420px] mx-auto text-sm font-normal text-[#818181] italic">
          {caption}
        </p>
      </div>

      {/* Mobile image */}
      <div className="lg:hidden w-full lg:w-1/2 max-w-full px-4 text-right">
        <div className="mt-10 lg:mt-0 rounded-[21px] mr-auto lg:mr-0 ml-auto text-center">
          <img
            src={image}
            alt="OurStory"
            className="w-full mb-2"
            height="841"
            width="663"
          />
          <p className="max-w-[420px] mx-auto text-sm font-normal text-[#818181] italic">
            {caption}
          </p>
        </div>
      </div>
    </div>
  );

  // Insert the image block after the 3rd paragraph
  contentWithImage.splice(3, 0, imageBlock);

  return (
    <section className="py-10 lg:py-20">
      <div className="w-full max-w-[1570px] px-4 mx-auto">
        <div className="flex flex-wrap items-center -mx-4">
          <div className="w-full max-w-full px-4 text-center lg:text-left">
            <h3 className="text-[30px] md:text-[40px] lg:text-[52px] font-normal leading-tight text-[#5fa3b2] mb-4">
              {title}
            </h3>
            {contentWithImage}
          </div>

          {/* Our Mission Block */}
          <div className="w-full max-w-full px-4 mt-10 lg:mt-14">
            <div
              className="p-10 lg:p-16 rounded-[21px] text-center"
              style={{
                backgroundImage: `url(${BoxBG})`,
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
              }}
            >
              <h2 className="text-[30px] md:text-[40px] lg:text-[52px] font-normal leading-none text-white mb-3">
                {titleMission}
              </h2>
              <p className="text-xl sm:text-2xl font-light leading-7 text-white italic max-w-[650px] mx-auto">
                {titleMissionDetail}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default OurStorySection;